export default __webpack_public_path__ + "static/media/Thunderstorm.2c98c302.png";